// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.region-scroller-container {
    position: relative;
    justify-items: center;
    margin-top: 2rem;
    width: 100%;
    height: fit-content;
    background-color: #32621c88;
    border: solid 3px #32621c;
    border-radius: 6px;
}

div.video-clip-maker-preview-container {
    height: 100%;
}


div.video-clip-maker-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

div.video-clip-maker-context-container {
    margin: 1rem 3rem;
}

.clip-maker-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
}

.clip-maker-row-section.fill {
    flex: 1 1 auto;
    min-height: 0;
}

.clip-maker-row-section.fit {
    flex: 0 1 auto;
}

div.clip-maker-preview {
    height: 100%;
}

div.video-clip-maker-title {
    display: flex;
    justify-content: center;
    margin: 1rem;
}

    div.video-clip-maker-title > span {
        font-size: 22pt;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/VideoClipMaker.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;IAEI;QACI,eAAe;IACnB","sourcesContent":[".region-scroller-container {\r\n    position: relative;\r\n    justify-items: center;\r\n    margin-top: 2rem;\r\n    width: 100%;\r\n    height: fit-content;\r\n    background-color: #32621c88;\r\n    border: solid 3px #32621c;\r\n    border-radius: 6px;\r\n}\r\n\r\ndiv.video-clip-maker-preview-container {\r\n    height: 100%;\r\n}\r\n\r\n\r\ndiv.video-clip-maker-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\ndiv.video-clip-maker-context-container {\r\n    margin: 1rem 3rem;\r\n}\r\n\r\n.clip-maker-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.clip-maker-row-section.fill {\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n}\r\n\r\n.clip-maker-row-section.fit {\r\n    flex: 0 1 auto;\r\n}\r\n\r\ndiv.clip-maker-preview {\r\n    height: 100%;\r\n}\r\n\r\ndiv.video-clip-maker-title {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 1rem;\r\n}\r\n\r\n    div.video-clip-maker-title > span {\r\n        font-size: 22pt;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
